export enum EnumPlacePageSectionKey {
  ABOUT = 'ABOUT',
  PREFERENCES = 'PREFERENCES',
}
